import * as React from "react";
import Button from "./button";
import TruncateAddress from "../utils/truncateAddress";

interface WhitelistAddSuccessMessageProps {
  className?: string;
  walletAddress?: string;
  walletCount?: number;
  onClose: () => void;
  onClick: () => void;
}

export default function WhitelistAddSuccessMessage({
  className,
  walletAddress,
  walletCount,
  onClose,
  onClick,
}: WhitelistAddSuccessMessageProps) {
  return (
    <div className={`${className}`}>
      <div className="relative">
        <header className="relative flex justify-between items-center pl-[20px] pr-[20px] pt-[12px] pb-[12px] bg-[#0099FE]">
          <div className="text-[30px]">
            <span>INFORMATION</span>
          </div>
          <div
            className="absolute right-[20px] w-[29px] h-[29px] hover:cursor-pointer"
            onClick={onClose}
          >
            <img src="/assets/cancel.svg" alt="cancel" />
          </div>
        </header>
        <main className="flex flex-col justify-center bg-black items-center pt-[30px] pb-[50px] pl-[30px] pr-[30px] text-[21px]">
          <h1 className="text-[28px] text-white mb-[20px]">
            ADDING TO WHITELIST
          </h1>
          {walletCount === 1 ? (
            <div className="max-w-[100%] text-[24px] text-white leading-[1.2]">
              <p>
                YOU HAVE <span className="text-[#00FF00]">ADDED</span>
              </p>
              <TruncateAddress
                address={walletAddress ?? ""}
                className={`truncate flex-1 text-[#00FF00]`}
              />
              <p>TO THE WHITELIST!</p>
            </div>
          ) : (
            <p className="text-[24px] text-white leading-[1.2] break-words break-all w-full">
              YOU HAVE <span className="text-[#00FF00]">ADDED </span>
              <span className="text-[#00FF00]">
                <br /> {walletCount} WALLETS <br />
              </span>{" "}
              TO THE WHITELIST!
            </p>
          )}
          <div className="pt-[30px] w-full">
            <Button
              className="w-full custom-aspect-320-63 text-[24px] hover:cursor-pointer hover:scale-105 transition-transform duration-300 ease-in-out"
              image="/assets/button.svg"
              text="OK"
              onClick={onClick}
            />
          </div>
        </main>
      </div>
    </div>
  );
}
